import { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  updateDoc,
  doc,
  deleteDoc,
} from "firebase/firestore";
import { db } from "../../../firebase/config";

type League = {
  fullName: string;
  description: string;
  creator: string;
  athletesArray: string[];
  docId?: string;
};

export default function LeagueTable() {
  const [leagues, setLeagues] = useState<League[]>([]);
  const [athleteInputs, setAthleteInputs] = useState<{ [key: string]: string }>(
    {}
  );

  useEffect(() => {
    const fetchLeagues = async () => {
      const snapshot = await getDocs(collection(db, "leagues"));
      const data = snapshot.docs.map((docSnap) => ({
        ...(docSnap.data() as League),
        docId: docSnap.id,
      }));
      setLeagues(data);
    };
    fetchLeagues();
  }, []);

  const handleAddAthlete = async (league: League) => {
    const newId = athleteInputs[league.docId!] || "";
    if (!newId) return;
    const updated = [...league.athletesArray, newId];
    await updateDoc(doc(db, "leagues", league.docId!), {
      athletesArray: updated,
    });
    setLeagues((prev) =>
      prev.map((l) =>
        l.docId === league.docId ? { ...l, athletesArray: updated } : l
      )
    );
    setAthleteInputs((prev) => ({ ...prev, [league.docId!]: "" }));
  };

  const handleDelete = async (league: League) => {
    await deleteDoc(doc(db, "leagues", league.docId!));
    setLeagues((prev) => prev.filter((l) => l.docId !== league.docId));
  };

  const handleInputChange = (leagueId: string, value: string) => {
    setAthleteInputs((prev) => ({ ...prev, [leagueId]: value }));
  };

  return (
    <table className="admin-data-table">
      <thead>
        <tr>
          <th>Name</th>
          <th>Description</th>
          <th>Creator</th>
          <th>Athletes</th>
          <th>Add Athlete</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {leagues.map((league) => (
          <tr key={league.docId}>
            <td>{league.fullName}</td>
            <td>{league.description}</td>
            <td>{league.creator}</td>
            <td>
              <ul>
                {league.athletesArray.map((athlete, index) => (
                  <li key={index}>{athlete}</li>
                ))}
              </ul>
            </td>
            <td>
              <input
                className="admin-edit-input"
                placeholder="Athlete Email"
                value={athleteInputs[league.docId!] || ""}
                onChange={(e) =>
                  handleInputChange(league.docId!, e.target.value)
                }
              />
            </td>
            <td>
              <button onClick={() => handleAddAthlete(league)}>Add</button>
              <button onClick={() => handleDelete(league)}>Delete</button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
